import React, { useContext } from "react";
import { observer } from "mobx-react";

import classNames from "classnames";

import { EventContext } from "@gp/components";

import { AdditionalOfferButtonCore } from ".";

export const AdditionalOfferButton = observer(
	function AdditionalOfferButton(props: {
		additionalOfferCount: number;
		isSecondaryColumnsEmpty?: boolean;
		isEventFeatured?: boolean;
		displaySport?: boolean;
		isAdditionalOfferVisible?: boolean;
	}) {
		const event = useContext(EventContext);
		if (props.additionalOfferCount <= 0 && !event.betBuilder) {
			return (
				<div
					className={classNames(
						"offer__body__data offer__more",
						{
							// "offer__more--sml": props.displaySport || props.isAdditionalOfferVisible,
							"offer__more--sml": props.isAdditionalOfferVisible,
							"offer__more--stretch":
								!props.isSecondaryColumnsEmpty,
							"is-selected": props.isEventFeatured,
						},
						"is-empty"
					)}
				>
					&nbsp;
				</div>
			);
		}

		const wrapperDivClasses = classNames("offer__body__data offer__more", {
			// "offer__more--sml":props.displaySport || props.isAdditionalOfferVisible,
			"offer__more--sml": props.isAdditionalOfferVisible,
			"offer__more--stretch": !props.isSecondaryColumnsEmpty,
			"is-selected": props.isEventFeatured,
		});

		return (
			<div className={wrapperDivClasses}>
				<AdditionalOfferButtonCore
					additionalOfferCount={props.additionalOfferCount}
					isSecondaryColumnsEmpty={props.isSecondaryColumnsEmpty}
					isEventFeatured={props.isEventFeatured}
				/>
			</div>
		);
	}
);
